var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('potential',{ref:"potential"}),_c('roadshow',{ref:"roadshow",attrs:{"fix-header":_vm.fixRoadshowHeader}}),_c('Summary',{ref:"summary",attrs:{"fix-header":_vm.fixSummaryHeader}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }